import React, { useState, useEffect } from "react";
import { getTotaltFinansierat, getÖversiktInbetalningar } from "API/swesum";
import Textfield from "Components/UI/Form/Textfield";
import { LoadingButton } from "@mui/lab";
import { Paper } from "@mui/material";
import { usePopupNotificationContext } from "Context/NotificationPopup";
import DownloadIcon from "@mui/icons-material/Download";

export default function WorkflowCreateInternalReports() {
  const [fileName, setFileName] = useState("");
  const [byteCharacters, setByteCharacters] = useState();

  const [dateFinansierat, setDateFinansierat] = useState("");
  const [dateOversiktInbet, setDateOversiktInbet] = useState("");

  const [loading, setLoading] = useState(false);
  const { openSuccess, openError } = usePopupNotificationContext();

  useEffect(() => {
    const today = new Date().toISOString().split("T")[0];
    setDateFinansierat(today);
    setDateOversiktInbet(today);
  }, []);

  useEffect(() => {
    try {
      const byteNumbers = new Array(byteCharacters.length);

      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      const blob = new Blob([byteArray], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = fileName;
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (ex) {
      console.error(ex);
    } finally {
      setLoading(false);
    }
  }, [byteCharacters, fileName]);

  const fetchTotaltFinansierat = async () => {
    setLoading(true);

    if (setDateFinansierat === null) {
      openError("Inget datum är valt.");
      return;
    }

    var result = await getTotaltFinansierat(dateFinansierat);
    setByteCharacters(atob(result.data.Data.FileContent));
    setFileName(result.data.Data.FileName);
  };

  const fetchÖversiktInbetalningar = async () => {
    setLoading(true);

    if (setDateOversiktInbet === null) {
      openError("Inget datum är valt");
      return;
    }

    var result = await getÖversiktInbetalningar(dateOversiktInbet);
    setByteCharacters(atob(result.data.Data.FileContent));
    setFileName(result.data.Data.FileName);
  };

  const containerStyle = { padding: "1rem", gap: "0.5rem", display: "grid" };
  const buttonStyle = { width: "100%" };

  function DownloadButton({ text, onClick }) {
    return (
      <LoadingButton
        color="success"
        variant="contained"
        onClick={() => onClick()}
        startIcon={<DownloadIcon />}
        style={buttonStyle}
        loading={loading}
      >
        {text}
      </LoadingButton>
    );
  }

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
        gridAutoRows: "auto",
        gap: "1rem",
      }}
    >
      <Paper style={containerStyle}>
        <Textfield
          fullWidth
          label="Datum (YYYY-MM-DD)"
          value={dateFinansierat}
          onChange={(e) => setDateFinansierat(e.target.value)}
        />
        <DownloadButton
          text="Totalt finansierat"
          onClick={fetchTotaltFinansierat}
        />
      </Paper>
      <Paper style={containerStyle}>
        <Textfield
          fullWidth
          label="Datum (YYYY-MM-DD)"
          value={dateOversiktInbet}
          onChange={(e) => setDateOversiktInbet(e.target.value)}
        />
        <DownloadButton
          text="Översikt inbetalningar"
          onClick={fetchÖversiktInbetalningar}
        />
      </Paper>
    </div>
  );
}
